module.exports = "\n\n<cms-tasks ></cms-tasks>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/project/taskManager-ang7/taskManager.component.html
// module id = 1806
// module chunks = 0